export default __webpack_public_path__ + "static/media/user.30b9d02e.svg";